import {Button, Dialog, DialogActions, DialogContent, DialogTitle} from "@mui/material"
import React from "react"
import {Trans} from "@lingui/macro";

interface DeleteContractModalProps {
    onClose: () => void
    contractId: string
    delete: (contractId: string) => void
}

interface DeleteContractModalState {

}

export class DeleteContractModal extends React.Component<DeleteContractModalProps, DeleteContractModalState> {
    render(){
        return(
            <Dialog open={true} onClose={this.props.onClose}>
                <DialogTitle>
                    <Trans id={"delete-contract-modal.title"}>
                        Eliminazione contratto
                    </Trans>
                </DialogTitle>
                <DialogContent>
                    <Trans id={"delete-contract-modal.body"}>
                        L'operazione è irreversibile.  Sicuro di voler eliminare il contratto selezionato?
                    </Trans>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.onClose}
                            variant={"contained"}
                            color="neutral"
                            sx={{
                                textTransform: "none",
                                mr: 1,
                                width: 100
                            }}
                            disableElevation>
                        <Trans id={"delete-contract-modal.close-button"}>
                            Annulla
                        </Trans>
                    </Button>
                    <Button onClick={() => this.props.delete(this.props.contractId)}
                            variant="contained"
                            sx={{
                                backgroundColor: 'secondary.main',
                                color: 'white',
                                mr: 1,
                                textTransform: "none",
                                width: 100
                            }}
                    >
                        <Trans id={"delete-contract-modal.confirm-button"}>Conferma</Trans>
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}
